export const item = (state) => (index) => {
  return state.items[index]
}

export function ready (state) {
  return state.ready
}

export function currentItem (state) {
  return state.currentItem
}

export function loading (state) {
  return state.loading
}

export function items (state) {
  return state.items
}

// not part of the meal items
export function filtredItems (state) {
  // console.log('items', state.items)
  return state.items.filter(it => !it.get('meal'))
}

export const getItemIndexById = (state) => (id) => {
  return state.items.findIndex(it => it._localId === id)
}

// export function enabledExtras (state) {
//   return state.enabledExtras
// }

export const itemsCountById = (state) => (itemId) => {
  return state.itemsCountById[itemId]
}

export const hasDuplication = (state) => (restaurantItemId) => {
  if(!state.items[0] || !restaurantItemId) return false

  let duplications = 0
  state.items.forEach(item => {
    const restItem = item.get('restaurant_item')
    const restId = restItem?.id || restItem?.objectId
    if(restId === restaurantItemId) {
      duplications++
    }
  })

  return duplications > 0
}
